import List from "@/components/list";
import router from "@/router";
import "./table.scss";

const Table = args => {
  const { listeners, props } = args;
  const RCSelectionChange = args.listeners["selection-change"] || function () { };
  const handleDelete = listeners["handleDelete"] || function () { };
  const showImg = listeners["showImg"] || function () { };
  const setDown = listeners["setDown"] || function () { };
  const handleNum = listeners["handleNum"] || function () { };
  const homeConfig = listeners["homeConfig"] || function () { };


  function handleEdit(data) {
    router.push({
      path: "courseTicketManage/add",
      query: {
        id: data.uuid,
      },
    });
  }
  function toDetail(item) {
    router.push({
      path: "courseTicketManage/add",
      query: {
        id: item.uuid,
        isDetailPage: 1
      },
    });
  }
  // 直播间管理-管理
  function goTicketManage(item) {
    router.push({
      path: "courseTicketManage/reserveManage",
      query: {
        uuid: item.uuid,
      },
    });
  }

  const Deal = ({ props: { vo } }) => {
    let dealConf = [];
    // 上线
    if (vo.row.onlineStatus == 1) {
      dealConf.push(["icon-edit-disable", "编辑", () => { }, "course:ticket:update"]);
      dealConf.push([ "icon-delete-disable", "删除", () => { }, "course:ticket:delete" ]);
      dealConf.push([
        "icon-down",
        "下线",
        () => setDown(vo.row.uuid, 0),
        "course:ticket:online"
      ]);
    } else {
      // 下线
      if (vo.row.canUpdate == 0) {
        dealConf.push(["icon-edit-disable", "编辑", () => { }, "course:ticket:update"]);
      } else {
        dealConf.push(["icon-edit", "编辑", () => handleEdit(vo.row), "course:ticket:update"]);
      }
      dealConf.push(["icon-delete", "删除", () => handleDelete(vo.row), "course:ticket:delete"]);
      dealConf.push([
        "icon-up",
        "上线",
        () => setDown(vo.row.uuid, 1),
        "course:ticket:online"
      ]);
    }
    dealConf.push(["iconfont icyuyueguanli_sel iconfont-adapt", "预约管理", () => goTicketManage(vo.row), "courseTicketManage:reserveManage"])
    dealConf.push(["iconfont iczengjiaminge_sel iconfont-adapt", "增加名额", () => handleNum(vo.row, 1), "course:ticket:count:update"])
    dealConf.push(["iconfont ickouchukucun_sel iconfont-adapt", "扣除库存", () => handleNum(vo.row, 2), "course:ticket:count:update"])

    if (vo.row.showDeptUpdate == 1) {
      if (vo.row.onlineStatus == 1) {
        dealConf.push(["iconfont icshouyerukoupeizhi_nor iconfont-adapt-disabled", "首页入口配置", () => {}, "course:ticket:index:config"])
      } else {
        dealConf.push(["iconfont icshouyerukoupeizhi_sel iconfont-adapt", "首页入口配置", () => homeConfig(vo.row), "course:ticket:index:config"])
      }
    }
    
    // v-permission={item[2]}
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const TicketName = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <span
        class="live-name"
        onClick={() => {
          toDetail(item);
        }}
      >
        {item.ticketName}
      </span>
    );
  };

  const Img = ({ props: { vo } }) => {
    return (
      <div onClick={() => showImg(vo.row)}>
        <img
          class='live-image'
          src={
            vo.row.topUrl
          }
        />
      </div>
    );
  };

  const Status = ({ props: { vo } }) => {
    const item = vo.row;
    let onlineStatusName = item.onlineStatus == 0 ? "下线" : "上线";
    return (
      <div>{onlineStatusName}</div>
    )
  };
  const LiveRoomName = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <span class="ellipsis--l2">{item.liveRoomName}</span>
    )
  };
  const ClassName = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <span class="ellipsis--l2">{item.className}</span>
    )
  };
  // 预约时间
  const CourseTimeList = ({ props: { vo } }) => {
    const timeList = vo.row.courseTimeList;
    if (timeList && timeList.length > 0) {
      return (
        <div class="time-item">
          {timeList.map((item, i) => (
            i == 0 && timeList.length == 2 ?
              <span>{item}<br /></span>
              : <span>{item}</span>
          ))}
        </div>
      );
    } else {
      return (
        <div class="time-item"> -- </div>
      );
    }
  };

  const AccountTableConfig = [
    // {
    //   type: "selection",
    //   label: "main"
    // },
    {
      label: "预约名称",
      minWidth: "150",
      showOverflowTooltip: true,
      render: vo => <TicketName vo={vo} />
    },
    {
      label: "详情页头图",
      width: "190",
      render: vo => <Img vo={vo} />
    },
    // {
    //   label: "首页展示时间",
    //   prop: "showDate",
    //   width: "150"
    // },
    {
      label: "预约时间",
      prop: "courseTimeList",
      minWidth: "320",
      render: vo => <CourseTimeList vo={vo} />,
    },
    {
      label: "关联直播",
      prop: "liveRoomName",
      width: "180",
      render: vo => <LiveRoomName vo={vo} />,
      showOverflowTooltip: true,
    },
    {
      label: "关联班级",
      prop: "className",
      width: "180",
      render: vo => <ClassName vo={vo} />,
      showOverflowTooltip: true,
    },
    {
      label: "状态",
      width: "90",
      render: vo => <Status vo={vo} />
    },
    {
      label: "创建时间",
      prop: "createDate",
      width: "160",
    },
    {
      label: "操作",
      width: "150",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
